<div [formGroup]="form" class="form-group">
  <div style="display: flex"
   [ngClass]="{
    'labelHidden':IsFromForm && (!label || (IsFormFieldNameHidden && !infoText)),
    'labelShow':IsFromForm && label && !IsFormFieldNameHidden && infoText && DisplayOnScreen
    }
  ">
    <span *ngIf="IsFromForm && IsInfoVisible && infoText && !DisplayOnScreen" class="ng-binding d-flex align-items-center">
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <span *ngIf="!IsFromForm && infoText">
      <i class="icon-info" [title]="infoText"></i>
    </span>
    <div>
      <!-- <span *ngIf="!DisplayOnScreen && IsRowDisplayOnScreen" class="d-block"><br></span> -->
      <label *ngIf="label && !IsFormFieldNameHidden" [for]="inputId" [ngClass]="IsFromForm ? 'field-title':''" [id]="'label-' + inputId">{{ label }}</label>
      <span *ngIf="label && (required || getErrorMessage() === requiredMessage || control.hasValidator(validator)) && !control?.value && !disabled" class="text-danger" aria-hidden="true">
        *
      </span>
      <span *ngIf="IsFromForm && IsInfoVisible && infoText && DisplayOnScreen">
        <br *ngIf="!IsFormFieldNameHidden">
        <i [ngClass]="isTextVisible ? 'icon-chv-down' : 'icon-chv-up'" class="toggle-icon" title="Toggle Text"
          *ngIf="AllowMinimize" (click)="toggleText()" (keydown)="$event.preventDefault()"></i>
        <span [class.hidden-text]="!isTextVisible" class="info-text" [id]="inputId + '-info'">
          {{ infoText }}
        </span>
      </span>
    </div>
  </div>

  <div class="form-group-control">
    <textarea
      *ngIf="!IsRichTextEditor"
      [id]="inputId"
      class="form-control"
      [formControlName]="controlName"
      [rows]="rows"
      [attr.aria-invalid]="hasErrors() ? 'true' : null"
      [attr.aria-describedby]="getAriaDescribedby()"
      [attr.aria-required]="isRequired ? 'true' : null"
      [ngClass]="{
        'is-invalid': control.dirty && control.errors,
        'required-mark': requiredMark,
        textarea: disabled === true
      }"
      style="white-space: initial"
    ></textarea>
    <angular-editor
    *ngIf="IsRichTextEditor"
    [id]="inputId"
    [formControlName]="controlName"
    appDefaultValueChange
    [config]="editorConfig"
    [attr.aria-invalid]="hasErrors() ? 'true' : null"
    [attr.aria-describedby]="getAriaDescribedby()"
    [attr.aria-required]="isRequired ? 'true' : null"
    [ngClass]="{'editor-disabled': disabled}"
    ></angular-editor>
  </div>
  <div *ngIf="control.dirty && control.errors" class="info-box error-box" [id]="inputId + '-error'">
    <span class="text-danger"> {{ errorMessagePrefix + getErrorMessage() }} </span>
  </div>
</div>
